import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import classnames from "classnames"

import styles from "./breadCrumb.css"

const BreadCrumb = ({ steps, theme = "dark" }) => {
  return (
    <nav aria-label="breadcrumb">
      <ol
        className={classnames(styles.root, { [styles.light]: theme === "light", [styles.dark]: theme === "dark" })}
        itemScope
        itemType="http://schema.org/BreadcrumbList"
      >
        {steps.map((step, index) => {
          const current = index === steps.length - 1
          const id = step.route.split("/").pop()
          const name = (
            <span itemProp="name" className={classnames({ [styles.current]: current })}>
              {step.name}
            </span>
          )
          return (
            <li className={styles.step} key={index} itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
              {steps.length === 1 || current ? (
                name
              ) : (
                <Link className={styles.link} to={{ pathname: step.route }} id={id} itemProp="item" href={step.route}>
                  {name}
                </Link>
              )}
              {!current && <span className={styles.separator}>/</span>}
              <meta itemProp="position" content={index + 1} />
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

BreadCrumb.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      route: PropTypes.string.isRequired,
    })
  ),
  theme: PropTypes.oneOf(["light", "dark"]),
}

export default BreadCrumb
